module.exports = __webpack_public_path__ + "static/media/shape1.pngfeat1.76ef083a.png";